import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${tokens.space.md};

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const CategoryCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${tokens.space.sm};
  padding: 0.85rem 1rem;
  background: ${tokens.surface.glass};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  cursor: pointer;
  transition: border-color ${tokens.motion.duration} ${tokens.motion.ease},
    background ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${tokens.accent.base};
    background: ${tokens.surface.raised};
  }
`

export const CategoryLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
  min-width: 0;
`

export const CategoryIcon = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.accent.base};

  svg {
    width: 1.1rem;
    height: 1.1rem;
  }
`

export const CategoryName = styled.p`
  margin: 0;
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const EditBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  border-radius: ${tokens.radius.control};
  border: 1px solid transparent;
  background: transparent;
  color: ${tokens.text.muted};
  cursor: pointer;
  transition: background ${tokens.motion.duration} ${tokens.motion.ease},
    color ${tokens.motion.duration} ${tokens.motion.ease};

  svg {
    width: 0.95rem;
    height: 0.95rem;
  }

  &:hover {
    background: ${tokens.surface.inset};
    color: ${tokens.text.primary};
  }
`
